export default "__VITE_ASSET__DwtKKxDl__"